/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Delivered_30dInputs */

const en_metric_delivered_30d = /** @type {(inputs: Metric_Delivered_30dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivered (30d)`)
};

const es_metric_delivered_30d = /** @type {(inputs: Metric_Delivered_30dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entregados (30d)`)
};

/**
* | output |
* | --- |
* | "Delivered (30d)" |
*
* @param {Metric_Delivered_30dInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const metric_delivered_30d = /** @type {((inputs?: Metric_Delivered_30dInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Delivered_30dInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_metric_delivered_30d(inputs)
	return es_metric_delivered_30d(inputs)
});